import { render } from "./LanguageDropdown.vue?vue&type=template&id=6981ca19&ts=true"
import script from "./LanguageDropdown.vue?vue&type=script&lang=ts"
export * from "./LanguageDropdown.vue?vue&type=script&lang=ts"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=6981ca19&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/TEU5NrXs6/1/developers/main/tms.engine/web.js/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__